import { Grow, keyframes, Menu } from "@mui/material";
import { lighten, styled } from "@mui/material/styles";

const CustomizedComponent = styled(Menu)(({ theme }) => ({
  "& .MuiMenuItem-root:hover": {
    color: theme.palette.secondary.main,
    backgroundColor: lighten(theme.palette.primary.main, 0.9),
    animationName: `${muiMenuItemHover}`,
    animationDuration: ".15s",
    animationIterationCount: "1",
    animationTimingFunction: "ease-in-out",
    "& .MuiSvgIcon-root": {
      animationName: `${muiSvgIconHover}`,
      animationDuration: ".3s",
      animationIterationCount: "1",
      animationTimingFunction: "ease-in-out",
      fill: theme.palette.secondary.main,
    },
  },
  "& .MuiMenuItem-root:active": {
    animationName: `${muiMenuItemActive}`,
    animationDuration: ".25s",
    animationIterationCount: "1",
    animationTimingFunction: "ease-in-out",
    "& .MuiSvgIcon-root": {
      animationName: `${muiMenuItemActive}`,
      animationDuration: ".5s",
      animationIterationCount: "1",
      animationTimingFunction: "ease-in-out",
    },
  },
}));

//#region Animations

const muiSvgIconHover = keyframes`
from {transform: scale(1) rotate(0deg);}
33% {transform: scale(1.10) rotate(2.5deg);}
66% {transform: rotate(-2.5deg);}
77% {transform: rotate(1.25deg);}
88% {transform: rotate(-1.25deg);}
to {transform: scale(1) rotate(0deg);}
`;

const muiMenuItemHover = keyframes`
from {transform: scale(1) rotate(0deg);}
33% {transform: scale(1.05) rotate(-.5deg);}
66% {transform: rotate(.5deg);}
to {transform: scale(1) rotate(0deg);}
`;

const muiMenuItemActive = keyframes`
from {transform: scale(1) rotate(0deg);}
50% {transform: scale(.95) rotate(-.5deg);}
to {transform: scale(1) rotate(0deg);}
`;

//#endregion

const OmniMenu = props => {
  return <CustomizedComponent TransitionComponent={Grow} {...props} />;
};

export default OmniMenu;
